
import * as React from "react";
import {Row } from 'antd';
import ReactECharts from 'echarts-for-react';
import { assert_key, getDecimal, getLineColor, getLineColorMap } from "../../../helper";

export interface IProps {
  consistency_package:any
}
export interface IState {
}

export default class ConsistencyChart extends React.Component<IProps, IState>{
    constructor(props:IProps) {
        super(props);
        this.renderConsistencyChart = this.renderConsistencyChart.bind(this);
        this.state = {
        }
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }

    public renderConsistencyChart = (consistency_package:any) => {
      let flag = assert_key(consistency_package, ["nodes","links"]);
      console.log(consistency_package);
        let enable_consistency_chart = flag;
        let consistency_chart_option = {};
        let decimal = getDecimal();
              
        if(enable_consistency_chart){
          
          consistency_chart_option =  {
          title: {
            //text: 'Consistency'
          },
          tooltip: {},
          animationDurationUpdate: 1500,
          animationEasingUpdate: 'quinticInOut',
          visualMap: {
            min: 0,
            max: 1,
            type: 'continuous',
            calculable: false,
            text: ["1", "0"],
            precision: decimal,
            inRange: {
              color: getLineColorMap()
            }
          },
          series: [
            {
              type: 'graph',
              layout: 'none',
              symbolSize: 50,
              roam: true,
              label: {
                show: true
              },
              edgeSymbol: ['circle'],
              edgeSymbolSize: [4, 10],
              edgeLabel: {
                fontSize: 20
              },
              
              data: consistency_package["nodes"],
              // links: [],
              links: consistency_package["links"],
              lineStyle: {
                opacity: 1,
                width: 5,
                curveness: 0
              }
            }
          ],
          
        };     
            return <ReactECharts option={consistency_chart_option} />
        }else{
            return <div />
        }
    }
    

    public render() {

        return this.renderConsistencyChart(this.props.consistency_package);
    }
}